/**
 * @fileoverview CATMS Crew PWA - Online Status Hook
 * @description Detects network connectivity changes
 */

import { useState, useEffect } from 'react';
import { isServerReachable } from '../utils/netGate';

/**
 * 端末の接続状態に加え、サーバーに届くか（utils/netGate の見張りが入っている会社のみ）も見る。
 * 船内Wi-Fiにつながっていてもインターネットに出られないときは「オフライン」として扱う。
 * 見張りは状態が変わると window に online / offline を送るので、下のイベントで追従する。
 */
export function useOnlineStatus(): boolean {
  const [isOnline, setIsOnline] = useState(() => navigator.onLine && isServerReachable());

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return isOnline;
}
